import * as yup from 'yup'

export const episodeSchema = yup.object({
    name: yup
        .string()
        .required('Episode Name is required')
        .min(3, 'Episode Name must be at least 3 characters')
        .max(40, 'Episode Name cannot exceed 40 characters'),

    short_summary: yup
        .string()
        .nullable()
        .max(75, 'Short Summary cannot exceed 75 characters'),

    creator: yup
        .string()
        .required('Creator is required')
        .min(3, 'Creator must be at least 3 characters')
        .max(60, 'Creator cannot exceed 60 characters'),

labels: yup
  .mixed()
  .transform((value) => {
    // Already an array → clean it
    if (Array.isArray(value)) {
      return value.map(v => String(v).trim()).filter(Boolean)
    }

    // String → split into array
    if (typeof value === 'string') {
      return value
        .split(',')
        .map(v => v.trim())
        .filter(Boolean)
    }

    return []
  })
  .test(
    'min-labels',
    'Please add at least one label',
    (value) => Array.isArray(value) && value.length > 0
  )
  .required('Please add at least one label'),

    thumbnail: yup
        .mixed()
        .required('Thumbnail is required')
        .test(
            'file-or-string',
            'Thumbnail must be a file or a valid string',
            (value) => {
                if (!value) return false;

                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        ),
    videoFile: yup
        .mixed()
        .required('Video is required')
        .test(
            'file-or-string',
            ' Video must be a file',
            (value) => {
                if (!value) return false;
                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        ),
    transcriptFile: yup
        .mixed()
        .nullable()
        .test(
            'is-file',
            'Transcript must be a valid file',
            (value) => {
                if (!value) return true; // Allow null/undefined
                return value instanceof File;
            }
        ),
})

export const editEpisodeSchema = yup.object({
    name: yup
        .string()
        .required('Episode Name is required')
        .max(40, 'Episode Name cannot exceed 40 characters'),

    short_summary: yup
        .string()
        .nullable()
        .max(75, 'Short Summary cannot exceed 75 characters'),

    creator: yup
        .string()
        .required('Creator is required')
        .min(3, 'Creator must be at least 3 characters')
        .max(60, 'Creator cannot exceed 40 characters'),

labels: yup
  .mixed()
  .transform((value) => {
    // Already an array → clean it
    if (Array.isArray(value)) {
      return value.map(v => String(v).trim()).filter(Boolean)
    }

    // String → split into array
    if (typeof value === 'string') {
      return value
        .split(',')
        .map(v => v.trim())
        .filter(Boolean)
    }

    return []
  })
  .test(
    'min-labels',
    'Please add at least one label',
    (value) => Array.isArray(value) && value.length > 0
  )
  .required('Please add at least one label'),





    thumbnail: yup
        .mixed()
        .required('Thumbnail is required')
        .test(
            'file-or-string',
            'Thumbnail must be a file',
            (value) => {
                if (!value) return false;

                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        )
})